import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiClient } from '../infrastructure/api-client/api-client';
import { AppRequest } from '../model/interfaces/app-request';
import { AppConfigService } from './app-config.service';

@Injectable({
    providedIn: 'root'
})
export class ContextService
{
    public request: AppRequest;
    private readonly apiClient: ApiClient;
    private clientOffsetMs: number;

    public constructor(apiClient: ApiClient, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
        this.init();
    }

    public getSystemTime(): Observable<Date>
    {
        return this.getClientTimeAberration().pipe(
            map(
                timeAberration =>
                {
                    const now = new Date();
                    now.setTime(now.getTime() + timeAberration);

                    return now;
                }
            )
        );
    }

    private init(): void
    {
        this.getClientTimeAberration().subscribe(t => t);
        this.initRequest();
    }

    /**
     * Initializes the request object by parsing the query parameters from the current window's URL.
     * 
     * - Extracts query parameters from `window.location.search` using a regular expression.
     *   The regular expression `([^?=&]+)(=([^&]*))?` matches key-value pairs in the query string.
     *   - `([^?=&]+)` captures the key.
     *   - `(=([^&]*))?` optionally captures the value after the `=` sign.
     * - Converts the extracted parameters into a `Map<string, string>` for easy access.
     * 
     * The resulting `this.request` object contains a `parameters` property, which is a map of
     * all query parameters with their keys converted to lowercase.
     */
    private initRequest(): void
    {
         
        const params = (window.location.search.match(new RegExp('([^?=&]+)(=([^&]*))?', 'g')) || [] as string[])
            .reduce(function (result: Record<string, string>, each: string)
            {
                const [key, value] = each.split('=');
                result[key.toLowerCase()] = value || '';
                return (result);
            }, {} as Record<string, string>);

        const parameters = new Map<string, string>();
        for (let key in params)
        {
            parameters.set(key, params[key]);
        }

        this.request = {
            parameters
        };
    }

    private getClientTimeAberration(): Observable<number>
    {

        // temp hack 
        this.clientOffsetMs = 0;


        if (this.clientOffsetMs != null)
        {
            return of(this.clientOffsetMs);
        }

      


        /*
        const webapiBasepath = this.environment.config['webapibasepath'];

        return this.apiClient.get<string>(new ServerTimeRequest(webapiBasepath)).pipe(
            map(serverTime =>
            {
                this.clientOffsetMs = new Date(serverTime).valueOf() - new Date().valueOf();
                return this.clientOffsetMs;
            })
        );
        */
    }
}
